import React from 'react';
import { FormGroup, Heading, Table, CheckboxInput } from 'arag-ui-lib';
import CONTENT_STRINGS from '../../../helpers/contentStrings';
import { FORM_GROUP_VARIANTS } from '../../../helpers/formGroupVariants';
import { CONTINGENT, HEADING_3, NON_CONTINGENT, REVERSE } from '../../../helpers/constants';
import { getStepMessage } from '../../../helpers/premiumSettingsFunctions';
import '../../../style/overviewTab.css';

const Step1 = (props) => {
    const {
        currentStep,
        caseStages,
        handleCaseStagesCheckedState,
        handleCaseStagesSelectMultipleChange,
        stepMessages,
        showNonContingentToggle,
        hasNonContingentPremium,
        handleToggleNonContingent,
        handleNonContingentCaseStagesChange,
        handleNonContingentCaseStagesCheckedState,
        nonContingentLocked,
        isPercentagePremium,
    } = props;

    if (currentStep !== 1)
        return null;

    const stepMessage = getStepMessage('1', stepMessages);
    // WI 98329: Percentage Premium policies support contingent premiums only.
    // WI 99823 AC1/AC2: nonContingentLocked is a PLC group or a Default Premium Setting (see
    // premiumSettingsWizardHOC). The toggle stays visible but unticked and read-only in both cases.
    const disableNonContingentToggle = isPercentagePremium || nonContingentLocked;
    const nonContingentChecked = nonContingentLocked ? false : hasNonContingentPremium;
    const showNonContingentColumn = showNonContingentToggle && nonContingentChecked;

    const columns = [
        {
            propertyName: 'name',
            header: CONTENT_STRINGS.CASE_STAGES,
            sortable: false,
            style: { textAlign: 'left', width: '400px' },
        },
        {
            propertyName: CONTINGENT,
            header: showNonContingentToggle ? CONTENT_STRINGS.CONTINGENT : '',
            sortable: false,
            style: { textAlign: 'center', width: '180px' },
            formatter: (row) => (
                <div style={{display: 'flex', justifyContent: 'center'}}>
                    <CheckboxInput
                        id={`contingent_${row.id}`}
                        name={`contingent_${row.id}`}
                        checked={handleCaseStagesCheckedState(row.id)}
                        onChange={(evt) => handleCaseStagesSelectMultipleChange(evt.target.checked, row)}
                        checkboxInputTestId={`edit-application-premium-setting-stages-case-stage-${row.id}`}
                    />
                </div>
            )
        },
        {
            propertyName: NON_CONTINGENT,
            header: CONTENT_STRINGS.NON_CONTINGENT,
            sortable: false,
            hidden: !showNonContingentColumn,
            style: { textAlign: 'center', width: '180px' },
            formatter: (row) => {
                // Locked/Percentage: block ticking a new stage, still allow un-ticking one already set.
                // (For a PLC/Default lock the whole column is hidden anyway; this matters for Percentage.)
                const isChecked = handleNonContingentCaseStagesCheckedState(row.id);
                return (
                    <div style={{display: 'flex', justifyContent: 'center'}}>
                        <CheckboxInput
                            id={`nonContingent_${row.id}`}
                            name={`nonContingent_${row.id}`}
                            checked={isChecked}
                            disabled={disableNonContingentToggle && !isChecked}
                            onChange={(evt) => handleNonContingentCaseStagesChange(evt.target.checked, row)}
                            checkboxInputTestId={`premium-setting-non-contingent-case-stage-${row.id}`}
                        />
                    </div>
                );
            }
        }
    ];

    return (
        <>
            <Heading
                variant={HEADING_3}
                title={stepMessage}
                headingTestId={'edit-application-premium-setting-instructions'}
            />

            {showNonContingentToggle && (
                <div
                    className={disableNonContingentToggle ? 'custom-reverse-checkbox non-contingent-disabled' : 'custom-reverse-checkbox'}
                    style={{marginTop: '15px', marginBottom: '15px'}}
                >
                    <FormGroup
                        labelSize={'col-sm-3 custom-label'}
                        inputSize={'col-sm-1'}
                        label={CONTENT_STRINGS.ADD_NON_CONTINGENT_PREMIUM}
                        variant={FORM_GROUP_VARIANTS.CHECKBOX}
                        inputProps={{
                            id: 'addNonContingentPremium',
                            name: 'addNonContingentPremium',
                            checked: nonContingentChecked,
                            disabled: disableNonContingentToggle,
                            onChange: (evt) => handleToggleNonContingent(evt.target.checked),
                        }}
                        groupShape={REVERSE}
                        formGroupTestId={'premium-setting-non-contingent-toggle'}
                    />
                </div>
            )}

            <Table
                columns={columns}
                data={caseStages}
                striped={true}
                tableHover={false}
                tableWrapperTestId={'premium-settings-case-stages'}
            />
        </>
    );
};

export default Step1;
